import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../../shared/shared.module';
import { AuthServiceLocal } from '../auth.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { FillExternalFormComponent } from './fill-external-form/fill-external-form.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { FillFormComponent } from '../../main/fill-form/fill-form.component';
import { RedirectComponent } from './redirect/redirect.component';
const router: Routes = [
  {path:"",component:LoginComponent,
children:[
  { path: '', redirectTo: 'redirect', pathMatch: 'full' },
  {path:"redirect",component:RedirectComponent, data: { state: 'signin' } },
  {path:"signin",component:SigninComponent, data: { state: 'signin' } },
  {path:"thankyou",component:ThankYouComponent, data: { state: 'signin' } },
  {path:"formfill",component:FillExternalFormComponent, data: { state: 'fill form' } },
  {path:"signup",component:SignupComponent, data: { state: 'signun' } },
  {path:"forgot-password",component:ForgotPasswordComponent, data: { state: 'forgot' } },
],
},
];

@NgModule({
  exports:[],
  imports: [CommonModule,SharedModule, RouterModule.forChild(router), FormsModule, ReactiveFormsModule, HttpClientModule],
  declarations: [LoginComponent,  SigninComponent, ForgotPasswordComponent, SignupComponent, FillExternalFormComponent, ThankYouComponent, RedirectComponent],
  providers:[AuthServiceLocal]
})
export class LoginModule { }
